const CourseContentIcon = () => {
  return (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.3754 11.875H16.0439C16.9644 11.875 17.7106 11.1288 17.7106 10.2083V4.79167C17.7106 3.87119 16.9644 3.125 16.0439 3.125H7.50228C6.5818 3.125 5.83561 3.87119 5.83561 4.79167V6.45833M12.7106 6.45833H3.96061C3.04014 6.45833 2.29395 7.20453 2.29395 8.125V13.5417C2.29395 14.4621 3.04014 15.2083 3.96061 15.2083H5.00228V17.2917L8.75228 15.2083H12.7106C13.6311 15.2083 14.3773 14.4621 14.3773 13.5417V8.125C14.3773 7.20453 13.6311 6.45833 12.7106 6.45833Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default CourseContentIcon